import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Users, Settings as SettingsIcon, CreditCard, LogOut, Building2, CalendarDays, LifeBuoy, Gift } from "lucide-react";
import { PoweredBy } from "@/components/PoweredBy";

export default function More() {
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const items = [
    { label: "I Miei Immobili", icon: Building2, path: "/properties" },
    { label: "Calendario", icon: CalendarDays, path: "/calendar" },
    { label: "Assistenza", icon: LifeBuoy, path: "/support" },
    ...(user?.role === "owner" ? [
      { label: "Invita & Guadagna", icon: Gift, path: "/referral" },
      { label: "Azienda", icon: SettingsIcon, path: "/settings" },
      { label: "Piano & Abbonamento", icon: CreditCard, path: "/upgrade" },
    ] : []),
  ];
  return (
    <div className="space-y-4">
      <h1 className="font-display text-2xl font-bold tracking-tight">Altro</h1>
      <div className="bg-card rounded-xl border border-border/80 divide-y divide-border/60">
        {items.map((i) => (
          <button key={i.path} onClick={() => navigate(i.path)} className="w-full flex items-center gap-3 px-4 py-3.5 text-left hover:bg-muted transition-colors">
            <i.icon className="h-5 w-5 text-primary" /> <span className="text-sm font-medium">{i.label}</span>
          </button>
        ))}
      </div>
      <button onClick={() => { logout(); navigate("/login"); }} className="w-full flex items-center gap-3 px-4 py-3.5 rounded-xl border border-border bg-card text-destructive hover:bg-destructive/5 transition-colors">
        <LogOut className="h-5 w-5" /> <span className="text-sm font-medium">Esci</span>
      </button>
      <PoweredBy className="pt-2" />
    </div>
  );
}
